export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">关于我们</h2>
          <p className="text-foreground-500 text-sm">吃瓜爆料网 — 做最懂你的娱乐资讯平台</p>
        </div>

        <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center">
                <i className="ri-rocket-2-line text-2xl text-primary-600"></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">极速爆料</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                7×24小时全天候监测娱乐圈动态，第一时间为你送上最新最热的八卦爆料，绝不错过任何一个瓜。
              </p>
            </div>
            <div>
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-accent-100 flex items-center justify-center">
                <i className="ri-shield-check-line text-2xl text-accent-600"></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">真实可靠</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                我们坚持多方核实、交叉验证的爆料原则，在速度与真实性之间找到最佳平衡，拒绝传播不实信息。
              </p>
            </div>
            <div>
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-secondary-100 flex items-center justify-center">
                <i className="ri-group-line text-2xl text-secondary-600"></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">社区共建</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                聚集全国最活跃的吃瓜群众，开放的评论区让每个人都能参与讨论，共同打造理性、有趣的吃瓜氛围。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}